/** @format */

import { useContext } from 'react';
import AuthContext, { type AuthContextValue } from 'src/contexts/KeyCloakContext';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
